export const settings_pricing_plan_en = {
  frequently_asked_questions: "Frequently Asked Questions",
  why_add_credit_card_question:
    "Why do I need to add my credit card to test the tool?",
  why_add_credit_card_answer:
    "Adding a credit card helps us verify you're a real person and prevents spam. You won't be charged. Since we rely on third-party email finder tools, free credits still cost us money. This quick verification step keeps the platform secure, supports real users, and helps us keep prices low.",
  if_charged_free_trial_question: "Will I be charged for the free trial?",
  if_charged_free_trial_answer:
    "No, adding your credit card is for verification only. You won't be charged unless you choose to upgrade later.",

  what_happens_after_add_card_question: "What happens after I add my card?",
  what_happens_after_add_card_answer:
    "After your first top-up, you will instantly receive additional free credits to test the tool, no matter how much - no strings attached!",

  features: "Features",
  search: "Search",
  per_page_limits: "Per page limits",
  total_page_limits: "Total page limits",
  record_upload_limits: "Record upload limits",
  export_limits: "Export limits",
  top_up_credits: "Top-up credits",
  record_selections: "Record selections",
  company_selection_limit: "Company Selection Limit",
  prospect_selection_limit: "Prospect Selection Limit",
  portal: "Portal",
  query_limit_per_hour: "Query Limit Per Hour",
  query_limit_per_day: "Query Limit Per Day",
  query_limit_per_month: "Query Limit Per Month",
  api: "API",
  call_limit_per_hour: "Call Limit Per Hour",
  call_limit_per_day: "Call Limit Per Day",
  call_limit_per_month: "Call Limit Per Month",
  pricing_plan_compare_all_plans: "Compare all plans",
  pricing_plan_title: "Pricing Plans",
  pricing_plan_desc: "Choose the plan that fits your needs. No hidden fees.",
  save_20: "Save 20%",
  pricing_plan_currency_list: "Currency list",
  most_popular: "Most popular",
  per_monthly: "month",
  per_annual: "annual",
  by_monthly: "monthly",
  by_annual: "annually",
  pricing_plan_per_cost: "Per user, per month — Billed {type}",
  pricing_plan_organization_desc:
    "Our Custom Plan offers flexible solutions and credits that suit your exact needs.",
  pricing_plan_credit_info:
    "Credits are our currency and are consumed when you perform certain actions on the platform.",
  exports: "Exports",
  get_in_touch: "Get in Touch",
  get_in_touch_desc:
    "Contact us today to discuss your needs and get a personalized quote",
  pricing_plan_learn_credits: "Learn more about credits",
  pricing_plans_primary_button_current: "Current plan",
  pricing_plans_primary_button_free: "Start free trial",
  pricing_plans_primary_button: "Get started",
  pricing_plans_primary_button_organization: "Contact us",

  free_feature_1: "300M+ prospects & company records",
  free_feature_2: "Verified emails & phone numbers",
  free_feature_3: "API Access",

  growth_feature_1: "Advanced filters & results",
  growth_feature_2: "Sequences & automation",
  growth_feature_3: "Web identification",
  growth_feature_4: "Permission profiles",

  business_feature_1: "All growth features",
  business_feature_2: "Analytics & pre-built report",
  business_feature_3: "Advanced security configurations",
  business_feature_4: "Team management",
  business_feature_5: "Priority support",

  organization_feature_1: "Full access to all tools",
  organization_feature_2: "Team and quota management",
  organization_feature_3: "Custom LinkedIn integration",
  organization_feature_4: "Sequences & automation",
  organization_feature_5: "Custom services",

  free_feature_title: "Free trial includes",
  growth_feature_title: "Growth includes",
  business_feature_title: "Business includes",
  organization_feature_title: "Organization includes",

  sequence_execution: "Sequence Execution",
  sequence_execution_details:
    "Each action performed consumes 0 credits.| Each action performed consumes 1 credit. |Each action performed consumes {0} credits.",
  ai_translation: "AI Translation",
  ai_translation_details:
    "Each AI translation result consumes 0 credits. | Each AI translation result consumes 1 credit. | Each AI translation result consumes {0} credits.",

  includes: "includes",

  pricing_plans_customize_feature_title: "Personalized Plan",
  pricing_plans_customize_feature_desc:
    "Our customized subscription service is designed to help organizations support business growth",

  settings_estimate_subscription: "Subscription:",
  settings_estimate_original_price: "Original Price:",

  permission_profiles: "Permission Profiles",
  team_management: "Team Management",
};

// Simplified Chinese
export const settings_pricing_plan_zhHans = {
  frequently_asked_questions: "常见问题",
  why_add_credit_card_question: "为什么需要添加信用卡？",
  why_add_credit_card_answer:
    "添加信用卡有助于我们验证您是真实用户，防止垃圾信息，而且您不会被收费。由于我们依赖第三方邮箱查找工具，免费额度实际上也会产生费用。这个快速的验证步骤可以保持平台安全，支持真实用户，并帮助我们维持低价。",
  if_charged_free_trial_question: "免费试用会收费吗？",
  if_charged_free_trial_answer: "不会，仅用于验证，除非升级不会收费。",
  what_happens_after_add_card_question: "添加后会怎样？",
  what_happens_after_add_card_answer:
    "首次充值后，您将立即获得额外的免费积分用于测试工具，无论金额多少——完全无附加条件！",
  features: "功能",
  search: "搜索",
  per_page_limits: "每页限制",
  total_page_limits: "总页数限制",
  record_upload_limits: "上传记录限制",
  export_limits: "导出限制",
  top_up_credits: "充值额度",
  record_selections: "记录选择",
  company_selection_limit: "公司选择上限",
  prospect_selection_limit: "潜在客户选择上限",
  portal: "平台",
  query_limit_per_hour: "每小时查询上限",
  query_limit_per_day: "每日查询上限",
  query_limit_per_month: "每月查询上限",
  api: "API",
  call_limit_per_hour: "每小时调用上限",
  call_limit_per_day: "每日调用上限",
  call_limit_per_month: "每月调用上限",
  pricing_plan_compare_all_plans: "比较所有方案",
  pricing_plan_title: "定价方案",
  pricing_plan_desc: "选择适合你的方案，无隐藏费用。",
  save_20: "节省 20%",
  pricing_plan_currency_list: "货币列表",
  most_popular: "最受欢迎",
  per_monthly: "月",
  per_annual: "年",
  by_monthly: "按月",
  by_annual: "按年",
  pricing_plan_per_cost: "每用户每月 - {type}计费",
  pricing_plan_organization_desc: "定制方案提供灵活额度和功能，满足您的需求。",
  pricing_plan_credit_info: "积分为平台通用单位，用于执行特定操作时消耗。",
  exports: "导出",
  get_in_touch: "联系我们",
  get_in_touch_desc: "欢迎联系我们，获取个性化报价",
  pricing_plan_learn_credits: "了解更多信用点数详情",
  pricing_plans_primary_button_current: "当前方案",
  pricing_plans_primary_button_free: "开始免费试用",
  pricing_plans_primary_button: "立即开始",
  pricing_plans_primary_button_organization: "联系我们",

  free_feature_1: "300M+ 潜在客户和公司记录",
  free_feature_2: "已验证的邮箱和电话号码",
  free_feature_3: "API 访问",

  growth_feature_1: "高级筛选和结果",
  growth_feature_2: "序列和自动化",
  growth_feature_3: "网页识别",
  growth_feature_4: "权限配置文件",

  business_feature_1: "所有高级功能",
  business_feature_2: "分析和预构建报告",
  business_feature_3: "高级安全配置",
  business_feature_4: "团队管理",
  business_feature_5: "优先支持",

  organization_feature_1: "完整工具访问权限",
  organization_feature_2: "团队与配额管理",
  organization_feature_3: "定制 LinkedIn 集成",
  organization_feature_4: "序列和自动化",
  organization_feature_5: "定制服务",

  free_feature_title: "免费计划包含",
  growth_feature_title: "初创计划包含",
  business_feature_title: "商务计划包含",
  organization_feature_title: "定制方案包含",

  sequence_execution: "工作流程执行",
  sequence_execution_details:
    "每个执行的操作将消耗 0 个积分。| 每个执行的操作将消耗 1 个积分。| 每个执行的操作将消耗 {0} 个积分。",
  ai_translation: "AI 翻译",
  ai_translation_details:
    "每次 AI 翻译结果将消耗 0 个积分。| 每次 AI 翻译结果将消耗 1 个积分。| 每次 AI 翻译结果将消耗 {0} 个积分。",
  includes: "包含",

  pricing_plans_customize_feature_title: "个性化方案",
  pricing_plans_customize_feature_desc:
    "我们的定制订阅服务旨在帮助组织支持业务增长",

  settings_estimate_subscription: "订阅费用:",
  settings_estimate_original_price: "原价:",

  permission_profiles: "权限配置文件",
  team_management: "团队管理",
};

// Traditional Chinese
export const settings_pricing_plan_zhHant = {
  frequently_asked_questions: "常見問題",
  why_add_credit_card_question: "為什麼需要新增信用卡來測試工具？",
  why_add_credit_card_answer:
    "添加信用卡有助於我們驗證您是真實用戶，防止垃圾訊息，而且您不會被收費。由於我們依賴第三方電郵搜尋工具，免費額度實際上亦會產生費用。這個快速的驗證步驟可以保持平台安全，支持真實用戶，並幫助我們維持低價。",
  if_charged_free_trial_question: "免費試用會收費嗎？",
  if_charged_free_trial_answer:
    "不會，新增信用卡僅作為驗證，除非您選擇升級，否則不會產生費用。",
  what_happens_after_add_card_question: "新增信用卡後會發生什麼？",
  what_happens_after_add_card_answer:
    "首次充值後，您將即時獲得額外的免費積分用於測試工具，無論金額多少——完全無附加條件！",
  features: "功能",
  search: "搜尋",
  per_page_limits: "每頁限制",
  total_page_limits: "總頁數限制",
  record_upload_limits: "上傳記錄限制",
  export_limits: "匯出限制",
  top_up_credits: "充值信用點數",
  record_selections: "記錄選取",
  company_selection_limit: "公司選取上限",
  prospect_selection_limit: "潛在客戶選取上限",
  portal: "平台",
  query_limit_per_hour: "每小時查詢上限",
  query_limit_per_day: "每日查詢上限",
  query_limit_per_month: "每月查詢上限",
  api: "API",
  call_limit_per_hour: "每小時呼叫上限",
  call_limit_per_day: "每日呼叫上限",
  call_limit_per_month: "每月呼叫上限",
  pricing_plan_compare_all_plans: "比較所有方案",
  pricing_plan_title: "方案價格",
  pricing_plan_desc: "選擇最適合您的方案，無任何隱藏費用。",
  save_20: "省下 20%",
  pricing_plan_currency_list: "貨幣列表",
  most_popular: "最受歡迎",
  per_monthly: "月",
  per_annual: "年",
  by_monthly: "按月計費",
  by_annual: "按年計費",
  pricing_plan_per_cost: "每位用戶每月 - {type}",
  pricing_plan_organization_desc:
    "客製方案提供彈性功能與信用點數，完全依您需求設計。",
  pricing_plan_credit_info: "信用點數是平台的通用貨幣，執行特定操作時會消耗。",
  exports: "匯出",
  get_in_touch: "聯絡我們",
  get_in_touch_desc: "歡迎與我們聯繫，獲取專屬報價與協助",
  pricing_plan_learn_credits: "了解更多信用點數資訊",
  pricing_plans_primary_button_current: "目前方案",
  pricing_plans_primary_button_free: "開始免費試用",
  pricing_plans_primary_button: "立即開始",
  pricing_plans_primary_button_organization: "聯絡我們",

  free_feature_1: "300M+ 潛在客戶和公司記錄",
  free_feature_2: "已驗證的郵箱和電話號碼",
  free_feature_3: "API 訪問",

  growth_feature_1: "高級篩選和結果",
  growth_feature_2: "序列和自動化",
  growth_feature_3: "網頁識別",
  growth_feature_4: "權限配置檔",

  business_feature_1: "所有高級功能",
  business_feature_2: "分析和預構建報告",
  business_feature_3: "高級安全配置",
  business_feature_4: "團隊管理",
  business_feature_5: "優先支持",

  organization_feature_1: "完整功能存取",
  organization_feature_2: "團隊與配額管理",
  organization_feature_3: "客製 LinkedIn 整合",
  organization_feature_4: "自動化序列",
  organization_feature_5: "專屬客製服務",

  free_feature_title: "免費計劃包含",
  growth_feature_title: "初創計劃包含",
  business_feature_title: "商務計劃包含",
  organization_feature_title: "定制方案包含",

  sequence_execution: "工作流程執行",
  sequence_execution_details:
    "每個執行的操作將消耗 0 點額度。| 每個執行的操作將消耗 1 點額度。| 每個執行的操作將消耗 {0} 點額度。",
  ai_translation: "AI 翻譯",
  ai_translation_details:
    "每次 AI 翻譯結果將消耗 0 點額度。| 每次 AI 翻譯結果將消耗 1 點額度。| 每次 AI 翻譯結果將消耗 {0} 點額度。",

  includes: "包含",
  pricing_plans_customize_feature_title: "個人化方案",
  pricing_plans_customize_feature_desc:
    "我們的客製化訂閱服務旨在協助組織推動業務成長",

  settings_estimate_subscription: "訂閱費用:",
  settings_estimate_original_price: "原價:",

  permission_profiles: "權限配置檔",
  team_management: "團隊管理",
};

// Japanese
export const settings_pricing_plan_ja = {
  frequently_asked_questions: "よくある質問",
  why_add_credit_card_question:
    "なぜツールを試すのにクレジットカードが必要ですか？",
  why_add_credit_card_answer:
    "クレジットカードの登録は、本物のユーザーであることを確認し、スパムを防止するためです。課金されることはありません。当社はサードパーティのメール検索ツールを使用しており、無料枠にも実際にはコストがかかります。この簡単な認証ステップにより、プラットフォームの安全性が保たれ、本物のユーザーをサポートし、低価格を維持できます。",
  if_charged_free_trial_question: "無料トライアルで課金されますか？",
  if_charged_free_trial_answer:
    "いいえ、クレジットカードの登録は認証のみを目的としており、アップグレードを選択しない限り課金されることはありません。",
  what_happens_after_add_card_question:
    "クレジットカードを登録するとどうなりますか？",
  what_happens_after_add_card_answer:
    "最初のチャージ後、金額に関係なく追加の無料クレジットが即時付与され、ツールをテストできます - 一切の条件なしです！",

  features: "機能",
  search: "検索",
  per_page_limits: "ページあたりの制限",
  total_page_limits: "総ページ制限",
  record_upload_limits: "レコードアップロード制限",
  export_limits: "エクスポート制限",
  top_up_credits: "クレジットチャージ",
  record_selections: "レコード選択",
  company_selection_limit: "会社選択上限",
  prospect_selection_limit: "見込み客選択上限",
  portal: "プラットフォーム",
  query_limit_per_hour: "1時間あたりのクエリ上限",
  query_limit_per_day: "1日あたりのクエリ上限",
  query_limit_per_month: "1ヶ月あたりのクエリ上限",
  api: "API",
  call_limit_per_hour: "1時間あたりのコール上限",
  call_limit_per_day: "1日あたりのコール上限",
  call_limit_per_month: "1ヶ月あたりのコール上限",

  pricing_plan_compare_all_plans: "全プランを比較",
  pricing_plan_title: "プラン料金",
  pricing_plan_desc:
    "隠れた費用なしで、あなたに最適なプランを選択してください。",
  save_20: "20%節約",
  pricing_plan_currency_list: "通貨リスト",
  most_popular: "人気プラン",
  per_monthly: "月額",
  per_annual: "年額",
  by_monthly: "月払い",
  by_annual: "年払い",
  pricing_plan_per_cost: "ユーザーあたり月額 - {type}",
  pricing_plan_organization_desc:
    "カスタムプランは、あなたのニーズに完全に合わせた柔軟な機能とクレジットを提供します。",
  pricing_plan_credit_info:
    "クレジットはプラットフォームの共通通貨で、特定の操作を実行すると消費されます。",

  exports: "エクスポート",
  get_in_touch: "お問い合わせ",
  get_in_touch_desc:
    "カスタム見積もりとサポートについてはお気軽にご連絡ください",
  pricing_plan_learn_credits: "クレジットの詳細",
  pricing_plans_primary_button_current: "現在のプラン",
  pricing_plans_primary_button_free: "無料トライアルを開始",
  pricing_plans_primary_button: "今すぐ開始",
  pricing_plans_primary_button_organization: "お問い合わせ",

  free_feature_1: "300M+ の見込み客と会社データ",
  free_feature_2: "検証済みのメールと電話番号",
  free_feature_3: "API アクセス",

  growth_feature_1: "高度なフィルターと結果",
  growth_feature_2: "シーケンスと自動化",
  growth_feature_3: "ウェブ識別",
  growth_feature_4: "権限プロファイル",

  business_feature_1: "すべての高度な機能",
  business_feature_2: "分析と事前構築されたレポート",
  business_feature_3: "高度なセキュリティ設定",
  business_feature_4: "チーム管理",
  business_feature_5: "優先サポート",

  organization_feature_1: "全機能へのアクセス",
  organization_feature_2: "チームとクォータ管理",
  organization_feature_3: "カスタムLinkedIn統合",
  organization_feature_4: "自動化シーケンス",
  organization_feature_5: "専用カスタムサービス",

  free_feature_title: "無料プランに含まれるもの",
  growth_feature_title: "スタートアッププランに含まれるもの",
  business_feature_title: "ビジネスプランに含まれるもの",
  organization_feature_title: "カスタムプランに含まれるもの",

  sequence_execution: "ワークフロー実行",
  sequence_execution_details:
    "実行ごとに0クレジット消費します。| 実行ごとに1クレジット消費します。| 実行ごとに{0}クレジット消費します。",
  ai_translation: "AI翻訳",
  ai_translation_details:
    "AI翻訳ごとに0クレジット消費します。| AI翻訳ごとに1クレジット消費します。| AI翻訳ごとに{0}クレジット消費します。",

  includes: "含まれるもの",
  pricing_plans_customize_feature_title: "カスタマイズプラン",
  pricing_plans_customize_feature_desc:
    "当社のカスタムサブスクリプションサービスは、組織のビジネス成長を推進するために設計されています",

  settings_estimate_subscription: "サブスクリプション:",
  settings_estimate_original_price: "元の価格:",
  permission_profiles: "権限プロファイル",
  team_management: "チーム管理",
};

// Korean
export const settings_pricing_plan_ko = {
  frequently_asked_questions: "자주 묻는 질문",
  why_add_credit_card_question:
    "도구를 테스트하기 위해 신용카드를 추가해야 하는 이유는 무엇인가요?",
  why_add_credit_card_answer:
    "신용카드 추가는 실제 사용자인지 확인하고 스팸을 방지하기 위한 것이며, 요금이 청구되지 않습니다. 당사는 제3자 이메일 검색 도구를 사용하고 있으며 무료 할당량에도 실제 비용이 발생합니다. 이 빠른 인증 단계는 플랫폼 보안을 유지하고 실제 사용자를 지원하며 저비용 유지에 도움이 됩니다.",
  if_charged_free_trial_question: "무료 체험판에서 요금이 청구되나요?",
  if_charged_free_trial_answer:
    "아니요, 신용카드 추가는 인증만을 위한 것이며 업그레이드를 선택하지 않는 한 요금이 청구되지 않습니다.",
  what_happens_after_add_card_question: "신용카드를 추가하면 어떻게 되나요?",
  what_happens_after_add_card_answer:
    "첫 충전 후 금액에 관계없이 추가 무료 크레딧이 즉시 제공되어 도구를 테스트할 수 있습니다 - 어떠한 조건도 없습니다!",

  features: "기능",
  search: "검색",
  per_page_limits: "페이지당 제한",
  total_page_limits: "총 페이지 제한",
  record_upload_limits: "레코드 업로드 제한",
  export_limits: "내보내기 제한",
  top_up_credits: "크레딧 충전",
  record_selections: "레코드 선택",
  company_selection_limit: "회사 선택 상한",
  prospect_selection_limit: "잠재 고객 선택 상한",
  portal: "플랫폼",
  query_limit_per_hour: "시간당 쿼리 상한",
  query_limit_per_day: "일일 쿼리 상한",
  query_limit_per_month: "월간 쿼리 상한",
  api: "API",
  call_limit_per_hour: "시간당 호출 상한",
  call_limit_per_day: "일일 호출 상한",
  call_limit_per_month: "월간 호출 상한",

  pricing_plan_compare_all_plans: "모든 플랜 비교",
  pricing_plan_title: "플랜 가격",
  pricing_plan_desc: "숨겨진 비용 없이 귀하에게 가장 적합한 플랜을 선택하세요.",
  save_20: "20% 절약",
  pricing_plan_currency_list: "통화 목록",
  most_popular: "인기 플랜",
  per_monthly: "월간",
  per_annual: "연간",
  by_monthly: "월별 결제",
  by_annual: "연간 결제",
  pricing_plan_per_cost: "사용자당 월 - {type}",
  pricing_plan_organization_desc:
    "맞춤형 플랜은 귀하의 필요에 완벽하게 맞춰진 유연한 기능과 크레딧을 제공합니다.",
  pricing_plan_credit_info:
    "크레딧은 플랫폼의 공통 통화로, 특정 작업을 실행할 때 소비됩니다.",

  exports: "내보내기",
  get_in_touch: "문의하기",
  get_in_touch_desc: "맞춤형 견적과 지원을 위해 저희에게 연락하세요",
  pricing_plan_learn_credits: "크레딧에 대해 더 알아보기",
  pricing_plans_primary_button_current: "현재 플랜",
  pricing_plans_primary_button_free: "무료 체험 시작",
  pricing_plans_primary_button: "지금 시작하기",
  pricing_plans_primary_button_organization: "문의하기",

  free_feature_1: "300M+ 잠재 고객 및 회사 기록",
  free_feature_2: "검증된 이메일 및 전화번호",
  free_feature_3: "API 액세스",

  growth_feature_1: "고급 필터 및 결과",
  growth_feature_2: "시퀀스 및 자동화",
  growth_feature_3: "웹 식별",
  growth_feature_4: "권한 프로필",

  business_feature_1: "모든 고급 기능",
  business_feature_2: "분석 및 사전 구축된 보고서",
  business_feature_3: "고급 보안 설정",
  business_feature_4: "팀 관리",
  business_feature_5: "우선 지원",

  organization_feature_1: "전체 기능 액세스",
  organization_feature_2: "팀 및 할당량 관리",
  organization_feature_3: "맞춤형 LinkedIn 통합",
  organization_feature_4: "자동화 시퀀스",
  organization_feature_5: "전용 맞춤형 서비스",

  free_feature_title: "무료 플랜 포함 사항",
  growth_feature_title: "스타터 플랜 포함 사항",
  business_feature_title: "비즈니스 플랜 포함 사항",
  organization_feature_title: "맞춤형 플랜 포함 사항",

  sequence_execution: "워크플로 실행",
  sequence_execution_details:
    "실행당 0크레딧 소모됩니다.| 실행당 1크레딧 소모됩니다.| 실행당 {0}크레딧 소모됩니다.",
  ai_translation: "AI 번역",
  ai_translation_details:
    "AI 번역당 0크레딧 소모됩니다.| AI 번역당 1크레딧 소모됩니다.| AI 번역당 {0}크레딧 소모됩니다.",

  includes: "포함 사항",
  pricing_plans_customize_feature_title: "맞춤형 플랜",
  pricing_plans_customize_feature_desc:
    "당사의 맞춤형 구독 서비스는 조직의 비즈니스 성장을 주도하도록 설계되었습니다",

  settings_estimate_subscription: "구독료:",
  settings_estimate_original_price: "원래 가격:",

  permission_profiles: "권한 프로필",
  team_management: "팀 관리",
};

// Hindi
export const settings_pricing_plan_hi = {
  frequently_asked_questions: "अक्सर पूछे जाने वाले प्रश्न",
  why_add_credit_card_question:
    "टूल टेस्ट करने के लिए क्रेडिट कार्ड क्यों जोड़ना होगा?",
  why_add_credit_card_answer:
    "क्रेडिट कार्ड जोड़ने से हमें वास्तविक उपयोगकर्ता सत्यापित करने में मदद मिलती है, स्पैम रोकता है, और आपसे कोई शुल्क नहीं लिया जाएगा। चूंकि हम तृतीय-पक्ष ईमेल खोज टूल्स पर निर्भर हैं, फ्री कोटा भी वास्तव में लागत उत्पन्न करता है। यह त्वरित सत्यापन चरण प्लेटफॉर्म सुरक्षित रखता है, वास्तविक उपयोगकर्ताओं को सपोर्ट करता है और हमें कम कीमत बनाए रखने में मदद करता है।",
  if_charged_free_trial_question: "क्या फ्री ट्रायल में कोई चार्ज लगेगा?",
  if_charged_free_trial_answer:
    "नहीं, क्रेडिट कार्ड केवल सत्यापन के लिए है। जब तक आप अपग्रेड नहीं चुनते, कोई शुल्क नहीं लगेगा।",
  what_happens_after_add_card_question:
    "क्रेडिट कार्ड जोड़ने के बाद क्या होगा?",
  what_happens_after_add_card_answer:
    "पहली रिचार्ज के बाद, आपको टूल टेस्ट करने के लिए तुरंत अतिरिक्त फ्री क्रेडिट्स मिलेंगे - बिना किसी शर्त के!",

  features: "फीचर्स",
  search: "खोज",
  per_page_limits: "प्रति पेज लिमिट",
  total_page_limits: "कुल पेज लिमिट",
  record_upload_limits: "रिकॉर्ड अपलोड लिमिट",
  export_limits: "एक्सपोर्ट लिमिट",
  top_up_credits: "क्रेडिट टॉप-अप",
  record_selections: "रिकॉर्ड चयन",
  company_selection_limit: "कंपनी चयन लिमिट",
  prospect_selection_limit: "प्रॉस्पेक्ट चयन लिमिट",
  portal: "पोर्टल",
  query_limit_per_hour: "प्रति घंटे क्वेरी लिमिट",
  query_limit_per_day: "प्रतिदिन क्वेरी लिमिट",
  query_limit_per_month: "मासिक क्वेरी लिमिट",
  api: "API",
  call_limit_per_hour: "प्रति घंटे API कॉल लिमिट",
  call_limit_per_day: "दैनिक API कॉल लिमिट",
  call_limit_per_month: "मासिक API कॉल लिमिट",

  pricing_plan_compare_all_plans: "सभी प्लान्स की तुलना करें",
  pricing_plan_title: "मूल्य निर्धारण योजना",
  pricing_plan_desc:
    "कोई छुपे हुए शुल्क नहीं, अपनी आवश्यकताओं के अनुरूप प्लान चुनें।",
  save_20: "20% बचत",
  pricing_plan_currency_list: "मुद्रा सूची",
  most_popular: "सबसे लोकप्रिय",
  per_monthly: "मासिक",
  per_annual: "वार्षिक",
  by_monthly: "मासिक बिलिंग",
  by_annual: "वार्षिक बिलिंग",
  pricing_plan_per_cost: "प्रति यूजर प्रति माह - {type}",
  pricing_plan_organization_desc:
    "कस्टम प्लान लचीली फंक्शनैलिटी और क्रेडिट्स प्रदान करते हैं, जो आपकी आवश्यकताओं के अनुरूप डिज़ाइन किए जाते हैं।",
  pricing_plan_credit_info:
    "क्रेडिट्स प्लेटफॉर्म की सामान्य मुद्रा हैं, विशिष्ट एक्शन्स करने पर खर्च होते हैं।",
  exports: "निर्यात",
  get_in_touch: "संपर्क करें",
  get_in_touch_desc: "कस्टम कोटेशन और सहायता के लिए हमसे संपर्क करें",
  pricing_plan_learn_credits: "क्रेडिट्स के बारे में अधिक जानें",
  pricing_plans_primary_button_current: "वर्तमान प्लान",
  pricing_plans_primary_button_free: "मुफ्त ट्रायल शुरू करें",
  pricing_plans_primary_button: "अभी शुरू करें",
  pricing_plans_primary_button_organization: "हमसे संपर्क करें",

  free_feature_1: "300M+ संभावित ग्राहक और कंपनी रिकॉर्ड",
  free_feature_2: "सत्यापित ईमेल और फोन नंबर",
  free_feature_3: "API एक्सेस",

  growth_feature_1: "उन्नत फ़िल्टर और परिणाम",
  growth_feature_2: "सीक्वेंस और स्वचालन",
  growth_feature_3: "वेब पहचान",
  growth_feature_4: "अनुमति प्रोफाइल",

  business_feature_1: "सभी उन्नत सुविधाएँ",
  business_feature_2: "विश्लेषण और पूर्व-निर्मित रिपोर्ट",
  business_feature_3: "उन्नत सुरक्षा कॉन्फ़िगरेशन",
  business_feature_4: "टीम प्रबंधन",
  business_feature_5: "प्राथमिकता समर्थन",
  organization_feature_1: "पूर्ण फंक्शनैलिटी एक्सेस",
  organization_feature_2: "टीम और कोटा मैनेजमेंट",
  organization_feature_3: "कस्टम LinkedIn इंटीग्रेशन",
  organization_feature_4: "ऑटोमेटेड सीक्वेंस",
  organization_feature_5: "डेडिकेटेड कस्टम सर्विस",

  free_feature_title: "फ्री प्लान में शामिल",
  growth_feature_title: "ग्रोथ प्लान में शामिल",
  business_feature_title: "बिजनेस प्लान में शामिल",
  organization_feature_title: "कस्टम प्लान में शामिल",

  sequence_execution: "वर्कफ्लो एक्जीक्यूशन",
  sequence_execution_details:
    "प्रत्येक एक्जीक्यूट की गई एक्शन 0 क्रेडिट खर्च करेगी।| प्रत्येक एक्जीक्यूट की गई एक्शन 1 क्रेडिट खर्च करेगी।| प्रत्येक एक्जीक्यूट की गई एक्शन {0} क्रेडिट खर्च करेगी।",
  ai_translation: "AI अनुवाद",
  ai_translation_details:
    "प्रत्येक AI अनुवाद परिणाम 0 क्रेडिट खर्च करेगा।| प्रत्येक AI अनुवाद परिणाम 1 क्रेडिट खर्च करेगा।| प्रत्येक AI अनुवाद परिणाम {0} क्रेडिट खर्च करेगा।",

  includes: "शामिल",
  pricing_plans_customize_feature_title: "पर्सनलाइज्ड प्लान",
  pricing_plans_customize_feature_desc:
    "हमारी कस्टम सब्सक्रिप्शन सेवा संगठनों को बिजनेस ग्रोथ ड्राइव करने में मदद करने के लिए डिज़ाइन की गई है",
  settings_estimate_subscription: "सदस्यता:",
  settings_estimate_original_price: "मूल मूल्य:",

  permission_profiles: "अनुमति प्रोफाइल",
  team_management: "टीम प्रबंधन",
};
